import { useContent } from "../../Core/Content/Provider";
import { PageHeaderPiece } from "../../Shared/Layout/Pieces";
import { getPhotographyPackagesFn } from "./Functions";
import { PackageCardPiece, PackageComparisonPiece } from "./Pieces";
import { FilmPackages } from "./FilmPackages";
import { Link } from "react-router-dom";

export const PackagesComponent = () => {
  const content = useContent("packages");
  const packages = getPhotographyPackagesFn();

  return (
    <section className="section-shell">
      <PageHeaderPiece
        eyebrow={content.eyebrow}
        title={content.title}
        description={content.description}
      />
      <nav aria-label="Package categories" className="mb-8 flex flex-wrap gap-5 text-sm"><a href="#photography">Photography ↓</a><a href="#film-production">Film & production ↓</a><Link to="/this-is-me#experiences">This is me campaign ↗</Link></nav>
      <div id="photography" className="grid gap-6 xl:grid-cols-2">
        {packages.map((packageItem) => (
          <PackageCardPiece key={packageItem.id} packageItem={packageItem} />
        ))}
      </div>
      <div className="panel-surface mt-10 p-6 sm:p-8">
        <p className="text-xs font-black uppercase text-cmj-gold">
          Quick comparison
        </p>
        <div className="mt-5 grid gap-4 lg:grid-cols-2">
          {packages.map((packageItem) => (
            <PackageComparisonPiece key={packageItem.id} packageItem={packageItem} />
          ))}
        </div>
      </div>
      <FilmPackages />
    </section>
  );
};
